import React from 'react';
import { motion } from 'framer-motion';
export function MethodSection() {
  const pillars = [{
    letter: 'M',
    title: 'Motivare',
    desc: 'Înainte să pui mâna pe orice sculă, construiești gândirea corectă. Înțelegi ce înseamnă să fii profesionist, de ce contează disciplina și cum arată drumul de la ucenic la meșter.'
  }, {
    letter: 'E',
    title: 'Efort',
    desc: 'Înveți că rezultatele vin din muncă constantă, nu din scurtături. Dezvolți obiceiul de a te prezenta în fiecare zi, de a face treaba bine și de a nu renunța la primul obstacol.'
  }, {
    letter: 'S',
    title: 'Specializare',
    desc: 'Alegi drumul tău: pipefitting, instalații sanitare și termice sau sudură TIG. Aprofundezi o direcție clară în loc să știi câte puțin din toate.'
  }, {
    letter: 'E',
    title: 'Experiență',
    desc: 'Treci de la teorie la practică. Lucrezi pe proiecte reale, îți construiești un portofoliu și înveți din greșeli ghidat de un mentor, nu pe pielea ta.'
  }, {
    letter: 'R',
    title: 'Responsabilitate',
    desc: 'Înveți siguranța muncii, regulile de pe șantier și ce înseamnă să îți asumi ce faci. Un profesionist adevărat știe că fiecare sudură și fiecare îmbinare contează.'
  }, {
    letter: 'I',
    title: 'Instruire',
    desc: 'Primești cunoștințe tehnice complete: de la citirea desenelor la estimări de costuri, de la întocmirea necesarului de materiale la ofertare. Tot ce îți trebuie ca să fii complet.'
  }, {
    letter: 'E',
    title: 'Evoluție',
    desc: 'Obții certificarea, îți construiești CV-ul profesional și primești mentorat dedicat pentru a te angaja bine. Eu te promovez direct către angajatorii din rețeaua mea.'
  }];
  return <section className="py-20 md:py-28 lg:py-32 bg-brand-dark overflow-hidden" data-id="element-140">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-20" data-id="element-141">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 md:mb-20" data-id="element-142">
          <h2 className="font-heading font-black text-3xl md:text-4xl lg:text-[44px] text-brand-white uppercase tracking-industrial mb-6" data-id="element-143">
            Metoda <span className="text-brand-accent" data-id="element-144">M.E.S.E.R.I.E.</span>
          </h2>
          <p className="font-sub font-medium italic text-brand-muted text-lg md:text-xl max-w-3xl mx-auto" data-id="element-145">
            Cei 7 pași prin care pleci de la zero și ajungi la un loc de muncă
            stabil în instalații. Cu cunoștințe reale, încredere în tine și un
            mentor alături.
          </p>
        </motion.div>

        {/* Full-width horizontal rows, stacked vertically */}
        <div className="flex flex-col gap-4" data-id="element-146">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.07
        }} className="w-full bg-brand-grey border border-brand-border rounded-lg hover:border-brand-accent transition-all duration-300 group" data-id="element-147">
              <div className="flex items-center gap-5 md:gap-8 p-5 md:p-6 lg:p-8" data-id="element-148">
                {/* Step number + Letter */}
                <div className="shrink-0 flex items-center gap-4 md:gap-6" data-id="element-149">
                  <span className="font-body text-brand-dim text-xs uppercase tracking-widest hidden sm:block w-12" data-id="element-150">
                    0{index + 1}
                  </span>
                  <div className="w-16 h-16 md:w-20 md:h-20 rounded-lg bg-brand-black border border-brand-border group-hover:border-brand-accent/50 flex items-center justify-center transition-colors" data-id="element-151">
                    <span className="font-heading font-black text-4xl md:text-5xl text-brand-accent leading-none" data-id="element-152">
                      {pillar.letter}
                    </span>
                  </div>
                </div>

                {/* Title + Description horizontal */}
                <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-8 flex-1 min-w-0" data-id="element-153">
                  <h3 className="font-heading font-bold text-lg md:text-xl text-brand-white uppercase tracking-wide shrink-0 md:w-52" data-id="element-154">
                    {pillar.title}
                  </h3>
                  <p className="font-body text-brand-muted text-sm md:text-base leading-relaxed" data-id="element-155">
                    {pillar.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* End marker */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="flex flex-col items-center mt-10" data-id="element-156">
          <div className="w-14 h-14 rounded-full bg-brand-accent flex items-center justify-center" data-id="element-157">
            <span className="font-heading font-black text-brand-black text-xl" data-id="element-158">
              ✓
            </span>
          </div>
          <span className="mt-3 font-heading font-bold text-brand-accent uppercase tracking-industrial text-sm" data-id="element-159">
            Pregătit pentru angajare
          </span>
        </motion.div>
      </div>
    </section>;
}